import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (translations[param]) return param;
    const saved = localStorage.getItem("mira-lang");
    return translations[saved] ? saved : "de";
  });

  const setLang = (code) => {
    setLangState(code);
    localStorage.setItem("mira-lang", code);
  };

  useEffect(() => {
    const seo = translations[lang].seo;
    document.documentElement.lang = lang;
    document.title = seo.title;
    const set = (sel, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute("content", val);
    };
    set('meta[name="description"]', seo.description);
    set('meta[property="og:title"]', seo.title);
    set('meta[property="og:description"]', seo.description);
    set('meta[name="twitter:title"]', seo.title);
    set('meta[name="twitter:description"]', seo.description);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
